import classnames from 'classnames'
import styles from './AppTitle.module.scss'
import { type ReactNode, isValidElement } from 'react'

export function isReactNode(node: any): node is ReactNode {
  return (
    typeof node === 'string'
    || typeof node === 'number'
    || typeof node === 'boolean'
    || node === null
    || node === undefined
    || (Array.isArray(node) && node.every(isReactNode))
    || isValidElement(node)
  )
}

type Props = {
  text: string | ReactNode;
  centered?: boolean;
  size?: 'md' | 'xs';
}

export function AppTitle({ text, centered, size }: Props): ReactNode {
  const sizeCl = size === 'md' && styles.md

  if (isReactNode(text)) {
    return (
      <span className={classnames(styles.root, centered && styles.centered, sizeCl)}>
        {text}
      </span>
    )
  }

  return (
    <span className={classnames(styles.root, centered ? styles.centered : '')} dangerouslySetInnerHTML={{ __html: text }} />
  )
}
